import apiClient from '@src/api/clients';

const BASE_URL = 'app1/task-loggers/';

const cleanParams = (params = {}) =>
  Object.fromEntries(
    Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== ''),
  );

export const listTaskLogs = (params = {}) =>
  apiClient.request({ url: BASE_URL, method: 'GET', payload: cleanParams(params) });

export const fetchTaskLog = (id, { includeMessages = false } = {}) =>
  apiClient.request({
    url: `${BASE_URL}${id}/`,
    method: 'GET',
    payload: includeMessages ? { include_messages: 'true' } : {},
  });

export default {
  listTaskLogs,
  fetchTaskLog,
};
